export const META = {
  home: {
    title: "MJ Kochuk | Staff Frontend Engineer",
    description:
      "React/Next.js specialist building performant web applications. 5+ years experience delivering scalable frontend architectures, real-time systems, and mentoring engineering teams.",
    keywords:
      "senior frontend engineer, react expert, next.js developer, technical lead, web performance, calgary, airdrie, canada",
  },
  projects: {
    title: "MJ Kochuk | Portfolio Projects",
    description:
      "Applications I've engineered - featuring AI dashboards, e-commerce platforms, and real-time data visualization systems.",
    keywords: "react portfolio, next.js case studies, web app examples, technical case studies",
  },
  contact: {
    title: "Hire MJ Kochuk | Frontend Engineering Contact",
    description:
      "Let's discuss your project needs. Available for senior frontend roles, technical leadership positions, and React/Next.js consulting engagements.",
    keywords: "hire react developer, frontend lead availability, technical consulting contact",
  },
  cater: {
    title: "MJ Kochuk | Job Analysis",
    description: "Professional workspace for job opportunity evaluation.",
    keywords: "",
    noIndex: true,
  },
};
